module.exports = __webpack_public_path__ + "img/blend.3744cf24.svg";